import { MaintenanceJob, RepairHistoryEntry } from '../models/maintenance.models';

export const MOCK_MAINTENANCE_JOBS: MaintenanceJob[] = [
  {
    id: '1',
    jobId: 'MJ-2026-001',
    assetName: 'Mercedes Sprinter',
    assetId: 'VAN-007',
    type: 'repair',
    description: 'Damaged bumper replacement',
    priority: 'high',
    assignedTo: 'John Doe',
    startDate: '2026-06-23',
    status: 'in-progress',
    icon: 'bi-truck'
  },
  {
    id: '2',
    jobId: 'MJ-2026-002',
    assetName: 'JBL Sound System',
    assetId: 'SS-003',
    type: 'maintenance',
    description: 'Annual service and cable check',
    priority: 'medium',
    assignedTo: 'Peter Nkosi',
    startDate: '2026-06-25',
    status: 'pending',
    icon: 'bi-speaker'
  },
  {
    id: '3',
    jobId: 'MJ-2026-003',
    assetName: 'Epson Projector',
    assetId: 'PRJ-102',
    type: 'inspection',
    description: 'Lens and lamp inspection',
    priority: 'low',
    assignedTo: 'Sarah Mokoena',
    startDate: '2026-06-18',
    status: 'completed',
    icon: 'bi-projector'
  }
];

export const MOCK_REPAIR_HISTORY: RepairHistoryEntry[] = [
  {
    id: '1',
    jobId: 'MJ-2026-003',
    assetName: 'Epson Projector',
    assetId: 'PRJ-102',
    repairType: 'inspection',
    description: 'Lens and lamp inspection',
    technician: 'Sarah Mokoena',
    completedDate: '2026-06-19',
    cost: 450,
    status: 'completed'
  },
  {
    id: '2',
    jobId: 'MJ-2025-089',
    assetName: 'JBL Sound System',
    assetId: 'SS-003',
    repairType: 'repair',
    description: 'Replaced faulty amplifier unit',
    technician: 'Peter Nkosi',
    completedDate: '2025-12-14',
    cost: 2800,
    status: 'warranty'
  }
];
